// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../static/css/font-awesome.min.css'
import '../static/css/style.css'

Vue.use(BootstrapVue)
Vue.config.productionTip = false

import VueScrollactive from "vue-scrollactive"
Vue.use(VueScrollactive);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App, VueScrollactive }
})



// WEBPACK FOOTER //
// ./src/main.js